import { render, staticRenderFns } from "./NPSTigoQuestion.vue?vue&type=template&id=50fa15f0&scoped=true&"
import script from "./NPSTigoQuestion.vue?vue&type=script&lang=js&"
export * from "./NPSTigoQuestion.vue?vue&type=script&lang=js&"
import style0 from "./NPSTigoQuestion.vue?vue&type=style&index=0&id=50fa15f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fa15f0",
  null
  
)

export default component.exports